module.exports = __webpack_public_path__ + "static/media/support2.1bf63752.png";